import React from "react";
import "./OverlaySlideBackground.scss";
import { MovingBars } from "../../../../../components/MovingBars/MovingBars";

interface IProps {

}

export function OverlaySlideBackground(props: IProps) {
    return (
        <div className="overlay-slide-background">
            <MovingBars count={3} />
        </div>
    )
}
